import React from "react";
import { PRIMARY_ALT } from "src/components/_shared/colors/colors";
import styled from "styled-components";


const Card = styled.div<{clickable: boolean}>`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: ${(props) => (props.clickable ? "pointer" : "default")};
`;

const ImageWrapper = styled.img`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  object-fit: cover;
  border-radius: 8px;
  z-index: 10;
  pointer-events: none;
  transition: transform 0.3s ease;
`;

const BadgeWrapper = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 15;
  background-color: #fff;
  color: #04171B;
  padding: 8px 12px;
  font-weight: 600;
  font-size: 16px;
  border-radius: 6px;
  letter-spacing: 0.5px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 16px;
  
  &:hover {
    h3, p {
      color: #0B617F;
    }
    
    ${ImageWrapper} {
      filter: brightness(1.1);
    }
  }
`;

export const ModelHomeCard = (props: IModelHomeCardProps) => {
  const {title, subtitle, clickEvent, badge, image} = props;
  return (
    <Container>
      <Card onClick={clickEvent} clickable={clickEvent != null}>
        <BadgeWrapper hidden={!badge || badge === ""}>
          {badge}
        </BadgeWrapper>
        {/* v5.0.3 HF image url*/}
        <ImageWrapper src={image} alt={`Model Home: ${title}`} />
      </Card>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <h3 style={{fontSize: "24px", fontWeight: "500", lineHeight: "32px", fontFamily: "p22-mackinac-pro"}}>{title}</h3>
          <p style={{ fontSize: "18px", fontWeight: "400", lineHeight: "28px", fontFamily: "inter"}}>{subtitle}</p>
        </div>
    </Container>
  );
};


interface IModelHomeCardProps {
  title: string;
  badge: string;
  subtitle: string;
  image: string;
  clickEvent?: () => void;
}
